import Login from "./../views/Login.vue";
import HomeGuest from "./../views/functionary/questionnarie/HomeGuest.vue";

import { routes as administravieRoutes } from "./administrative";
import { routes as functionaryRoutes } from "./functionary";

export const routes = [
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/",
    name: "login",
    component: HomeGuest,
  },
  ...administravieRoutes,
  ...functionaryRoutes,
  {
    path:'*',
    redirect:'/'
  }

  
];
